import React, { useEffect, useState } from "react";

interface ScrollToTopArrowProps {
  targetRef: React.RefObject<HTMLElement>;
}

const floatAnimation = `
@keyframes floatUpDown {
  0% { transform: translateY(0); }
  50% { transform: translateY(-16px); }
  100% { transform: translateY(0); }
}`;

const ScrollToTopArrow: React.FC<ScrollToTopArrowProps> = ({ targetRef }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Inject keyframes only once
  useEffect(() => {
    if (!document.getElementById("floatUpDownKeyframes")) {
      const style = document.createElement("style");
      style.id = "floatUpDownKeyframes";
      style.innerHTML = floatAnimation;
      document.head.appendChild(style);
    }
  }, []);

  const handleClick = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      style={{
        position: "fixed",
        bottom: 32,
        right: 32,
        zIndex: 1000,
        background: "#97afbc",
        border: "none",
        borderRadius: "50%",
        width: 56,
        height: 56,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        display: visible ? "flex" : "none",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "opacity 0.3s",
        opacity: visible ? 1 : 0,
        animation: visible ? "floatUpDown 2s ease-in-out infinite" : undefined,
      }}
      aria-label="Scroll to categories"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 3 18 9" />
        <line x1="12" y1="3" x2="12" y2="21" />
      </svg>
      <span style={{ color: "#fff", fontSize: "10px", marginTop: "2px" }}>Haut</span>
    </button>
  );
};

export default ScrollToTopArrow; 